<template>
  <div class="upload-contain flex justify-start flex-nowrap">
    <el-upload
      ref="upload"
      v-if="!fileId || copyFileList.length < limit"
      :style="{ ...classWH }"
      class="!mr-10px mb-10px avatar-upload border-1px border-dashed boder-color-default cursor-pointer hover:border-[var(--systemMainColor)]"
      action="string"
      :http-request="importListFile"
      :show-file-list="false"
      :auto-upload="false"
      :multiple="false"
      :limit="limit"
      :on-change="onChange"
      :disabled="isDisabledUploadComponent"
    >
      <i
        class="text-xl text-center"
        :class="[uploadIcon]"
        :style="{ ...classWH, 'line-height': `${uploadHeight}px` }"
      ></i>
    </el-upload>

    <div class="flex justify-start items-center flex-wrap" v-if="copyFileList.length > 0">
      <div
        class="upload-demo-list mr-10px mb-10px"
        :style="{ ...classWH }"
        v-for="(item, index) in copyFileList"
        :key="index"
      >
        <el-image fit="contain" class="w-full h-full" :src="item.imgContent" alt="" />
        <div class="w-full h-full demo-upload-list-cover">
          <i class="el-icon-view text-base" @click="handlePreview(item.imgContent)"></i>
          <i class="el-icon-download text-base ml-10px" @click="handleDownload(item.id)"></i>
          <i
            class="el-icon-delete text-base ml-10px"
            v-if="isShowDeleteButton"
            @click="handleDel(index)"
          ></i>
        </div>
      </div>
    </div>
    <el-image
      v-show="false"
      ref="elImage"
      :src="imgContent"
      :preview-src-list="baseImageList"
    ></el-image>
  </div>
</template>

<script>
import { FileApi } from '@wiz-api/file-management'

const fileApi = new FileApi()
export default {
  name: 'ImgUpload',
  model: {
    prop: 'fileId',
    event: 'change',
  },
  props: {
    // 0默认 1 私有 2公开
    authLevel: {
      type: Number,
      default: 0,
    },
    // 文件id
    fileId: {
      type: String,
      default: '',
    },
    // 可上传文件类型;为空数组时可以
    accept: {
      type: Array,
      default: () => {
        return ['jpg', 'png', 'jpeg']
        // 图片格式默认前3个
        // 'jpeg', 'gif', 'psd', 'bmp', 'tiff'
      },
    },
    // 限制图片尺寸宽高，例如： [375, 240]
    limitImgWHArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    // 限制单个图片大小,以M为单位
    maxSize: {
      type: Number,
      default: 100,
    },
    // 限制总的文件大小,以M为单位
    totalMaxSize: {
      type: Number,
      default: 300,
    },
    // 上传组件显示的图标,默认为上传图标
    uploadIcon: {
      type: String,
      default: 'el-icon-plus',
    },
    // 是否显示删除按钮
    isShowDeleteButton: {
      type: Boolean,
      default: true,
    },
    // 是否禁用上传组件
    isDisabledUploadComponent: {
      type: Boolean,
      default: false,
    },
    // 上传组件宽高自定义设置
    uploadWidth: {
      type: Number,
      default: 360,
    },
    // 上传组件宽高自定义设置
    uploadHeight: {
      type: Number,
      default: 180,
    },
    // 文件数量
    limit: {
      default: 1,
    },
  },
  data() {
    return {
      // 图片预览信息
      imgContent: null,
      // 文件对象
      files: null,
      // 文件列表
      fileList: [],
      // 文件复制对象
      copyFileList: [],
    }
  },
  created() {
    if (this.fileId) {
      this.getImgContent(this.fileId.split(','))
    } else {
      this.copyFileList = []
    }
  },
  computed: {
    baseImageList() {
      return this.copyFileList.map((i) => {
        return i.imgContent
      })
    },
    classWH() {
      return {
        width: `${this.uploadWidth}px !important`,
        height: `${this.uploadHeight}px`,
      }
    },
  },
  methods: {
    // 限制图片尺寸
    limitFileWH(limitWidth, limitHeight, file) {
      let valid = false
      const width = limitWidth
      const height = limitHeight
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = (e) => {
        const data = e.target.result
        const image = new Image()
        image.src = data
        image.onload = () => {
          valid = image.width === width && image.height === height
        }
      }
      return valid
    },
    // 图片上传覆盖方法
    async importListFile(params) {
      const name = params.file.name
      const fileSuffix = name.substring(name.lastIndexOf('.') + 1).toLowerCase()
      if (
        this.accept &&
        this.accept.length > 0 &&
        !this.accept
          .map((i) => {
            return i.toLowerCase()
          })
          .includes(fileSuffix)
      ) {
        this.$message({
          showClose: true,
          message: `上传文件只能是${this.accept.join('/')}`,
          type: 'warning',
        })
        this.$refs.upload.clearFiles()
        return
      }

      // 图片上传大小
      if (params.file.size / 1024 / 1024 > this.maxSize) {
        this.$message({
          showClose: true,
          message: `图片上传最大不能超过${this.maxSize}M`,
          type: 'warning',
        })
        this.$refs.upload.clearFiles()
        return
      }

      // 图片大小是否通过校验
      if (this.limitImgWHArr && this.limitImgWHArr.length === 2) {
        const valid = this.limitFileWH(this.limitImgWHArr[0], this.limitImgWHArr[1], params.file)
        if (!valid) {
          this.$message({
            showClose: true,
            message: `请上传尺寸为${this.limitImgWHArr[0]} * ${this.limitImgWHArr[1]}的图片`,
            type: 'warning',
          })
          this.$refs.upload.clearFiles()
          return
        }
      }
      // 图片上传尺寸
      this.imgUpload(params)
    },
    /**
     * 文件下载
     * @param {*} item 文件id和文件名称
     * @param {*} type download 下载 target 预览（针对pdf进行单独的预览）
     * @param {*} isShowMessageTip boolean, 是否显示下载成功提示字样
     */
    async handleDownload(fileId) {
      const [err, res] = await fileApi.download(fileId, { returnType: 'Blob' })
      if (!err) {
        const [versionErr, versionRes] = await fileApi.getFileInfoVersion(fileId)
        if (!versionErr) {
          this.exportFile(res, versionRes.name)
        }
      }
    },
    /**
     * 下载文件
     * @param {*} data 文件流
     * @param {*} name 文件名称
     * @param {*} type download 下载 target 预览（针对pdf进行单独的预览）
     * @param {*} isShowMessageTip boolean, 是否显示下载成功提示字样
     */
    exportFile(data, name) {
      const blob = new Blob([data], {
        type: 'application/pdf',
      })
      const blobUrl = window.URL.createObjectURL(blob)
      const templink = document.createElement('a')
      templink.style.display = 'none'
      templink.href = blobUrl
      templink.setAttribute('download', `${name}`)
      document.body.appendChild(templink)
      templink.click()
      document.body.removeChild(templink)
      window.URL.revokeObjectURL(blobUrl)
      this.$message({
        showClose: true,
        message: '下载成功!',
        type: 'success',
      })
    },
    // 图片上传请求
    async imgUpload(params) {
      const [err, res] = await fileApi.upload({
        authLevel: this.authLevel || 0,
        files: [params.file],
      })
      if (!err) {
        const copyFileList = [...this.copyFileList, ...res]
        const copyFilesId = copyFileList.map((item, index) => {
          return item.id
        })
        // 只用于人员证件上传回调
        this.files = params.file
        // 上传成功回调,用于拿到img的base64,身份证做特殊处理
        this.$emit('upload-success', this.files)

        this.getImgContent([res[0].id])
        this.$emit('change', copyFilesId.join(','))
      }
    },

    /**
     * 获取图片内容并进行预览
     * @param {*} fileId 文件id
     */
    async getImgContent(fileId) {
      const promiseList = []
      fileId.forEach(async (id) => {
        // 获取图片内容
        promiseList.push(fileApi.getFileContent(id))
      })
      Promise.all(promiseList)
        .then((fileList) => {
          fileList.forEach((item, index) => {
            const [err, res] = item
            if (!err) {
              const file = {
                id: fileId[index],
                imgContent: `data:image/jpg;base64,${res.content}`,
              }
              this.copyFileList.push(file)
            }
          })
        })
        .catch()
    },
    onChange(file, fileList) {
      this.$refs.upload.submit()
    },
    // 预览
    handlePreview(imgContent) {
      this.imgContent = imgContent
      this.$refs.elImage.clickHandler()
    },
    // 删除
    async handleDel(index) {
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          this.copyFileList.splice(index, 1)
          const copyFilesId = this.copyFileList.map((item, iIndex) => {
            return item.id
          })
          this.$emit('change', copyFilesId.join(','))
          this.$nextTick(() => {})
        })
        .catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.upload-demo-list {
  position: relative;
  .demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    & i {
      color: #ffffff;
    }
  }
}

.upload-demo-list:hover {
  .demo-upload-list-cover {
    display: block;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
}
</style>
